import AutoDeliveryResultPopup from '../../../components/AutoDeliveryResultPopup';
import {getRescheduleContent} from '../utils/getRescheduleContent';

interface RescheduleErrorPopupProps {
    onClose: () => void;
}

const RescheduleErrorPopup = ({onClose}: RescheduleErrorPopupProps) => {
    const {failurePopup} = getRescheduleContent() || {};

    if (!failurePopup) {
        return null;
    }

    return <AutoDeliveryResultPopup popup={failurePopup} onClose={onClose} onButtonClick={onClose} />;
};

export default RescheduleErrorPopup;
